module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-3"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'people'
      }
    }
  }, [_vm._v("\n                People\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("\n            Welcome\n        ")])]), _vm._v(" "), _c('h1', [_vm._v("Welcome")]), _vm._v(" "), _c('p', [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab accusantium assumenda dolor eligendi enim eos, impedit in ipsum laboriosam maxime mollitia natus necessitatibus neque, odit quia, quibusdam sed soluta totam.\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2533c06d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/people/views/Welcome.vue
// module id = 102
// module chunks = 1